// Pure mapping between the live canvas (WidgetInstance[], with session-only ids)
// and the persisted board (CanvasWidget[]). The store owns the live list; these
// are the persist ↔ live edges, kept pure so they're unit-tested without a store.

import type { CanvasWidget } from "@catbento/shared";
import type { WidgetInstance } from "./types.js";

/** Live → persisted: drop the session-only instanceId. */
export function toCanvasWidgets(instances: WidgetInstance[]): CanvasWidget[] {
  return instances.map(({ widgetKey, position, players, state }) => ({
    widgetKey,
    position,
    players,
    state,
  }));
}

/** Persisted → live: mint a fresh instanceId for each stored widget. */
export function fromCanvasWidgets(
  widgets: CanvasWidget[],
  mintId: () => string
): WidgetInstance[] {
  return widgets.map((w) => ({ instanceId: mintId(), ...w }));
}
